/**
 * PDM – Review Benefits Slider
 * This script initializes the Swiper carousel for the 
 * "PDM Review Benefits" section. It enables:
 * - Mobile swipe with pagination
 * - Desktop layout with auto-width slides centered within the section
 * - Proper spacing and mousewheel behavior
 */

document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  const el = document.querySelector('.pdm-review-benefits__swiper');
  if (!el) return;

  new Swiper(el, {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: false,
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      clickable: true,
    },
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: {
      769: {
        slidesPerView: 'auto',
        spaceBetween: 32,
        centeredSlides: false,
        centerInsufficientSlides: true,
        allowTouchMove: false
      }
    }
  });
});